import { Injectable } from "@angular/core";
import { Guid } from "guid-typescript";
import * as moment from "moment";
import { Model_ResponseWorkflow, QueryParams_ResponseWorkflow, STATUS_WORKFLOW } from 'src/app/app.models';
import { ResponseWorkflowOfflineDao } from './response-workflow-offline.dao';

const TB_RESPONSES_NAME = "LOCAL_TB_RESPONSES";

@Injectable()
export class ResponseWorkflowOfflineWebDao extends ResponseWorkflowOfflineDao {
    doDeleteSyncedResponsesAction(): Promise<void> {
        return new Promise(async (resolve, reject) => {
            let responses = await this.doGetResponsesAction();
            responses.forEach(async (response) => {
                if (response.SYNCED === true) {
                    await this.doDeleteResponsesAction(response.GUID_SYNCHRONISATION);
                }
            });
            resolve();
        });
    }

    doSyncResponsesAction(_responses: Model_ResponseWorkflow[]): Promise<void> {
        return new Promise((resolve, reject) => {
          this.doClearResponsesAction();
          this.doInsertResponsesAction(_responses).then(() => {
            resolve();
          }, err => reject(err));
        });
    }

    doDeleteResponsesAction(_guid: string): Promise<void> {
        return new Promise((resolve, reject) => {
            this.doGetResponsesAction()
            .then((_responses: Model_ResponseWorkflow[]) => {
                const responseIndex = _responses.findIndex(r => r.GUID_SYNCHRONISATION == _guid);
                if (responseIndex != -1) {
                    _responses.splice(responseIndex, 1);
                }
                localStorage.setItem(TB_RESPONSES_NAME, JSON.stringify(_responses));
                resolve();
            }, err => reject(err));
        });
    }

    doClearResponsesAction() {
        return new Promise<void>((resolve, reject) => {
            localStorage.setItem(TB_RESPONSES_NAME, "[]");
            resolve();
        })
    }

    doGetResponsesAction(_queryParams?: QueryParams_ResponseWorkflow): Promise<Model_ResponseWorkflow[]> {
        if (_queryParams === undefined) 
            _queryParams = new QueryParams_ResponseWorkflow();

        return new Promise((resolve, reject) => {
            var datas: Model_ResponseWorkflow[] = [];
            const storageDatas = localStorage.getItem(TB_RESPONSES_NAME);
            if (!!storageDatas && storageDatas != 'undefined' && storageDatas != 'null') {
                try {
                    datas = JSON.parse(storageDatas);
                    if (datas == null) { datas = []; }
                } catch(e) { console.log(e) }

                if (!!_queryParams.STATUS_WORKFLOW && _queryParams.STATUS_WORKFLOW.length > 0) {
                    datas = datas.filter(d => _queryParams.STATUS_WORKFLOW.lastIndexOf(d.STATUS_WORKFLOW) > -1);
                }

                if (_queryParams.SYNCED !== undefined) {
                    datas = datas.filter(d => d.SYNCED == _queryParams.SYNCED);
                }
            }
            resolve(datas);
        });
    }

    doInsertResponsesAction(_responses: Model_ResponseWorkflow[]): Promise<void> {
        return new Promise((resolve, reject) => {
            this.doGetResponsesAction().then((_datasTable: Model_ResponseWorkflow[]) => {
                var newDatas = _datasTable.concat(_responses);
                localStorage.setItem(TB_RESPONSES_NAME, JSON.stringify(newDatas));
                resolve();
            }, err => reject(err));
        });
    }

    doSaveResponsesAction(_response: Model_ResponseWorkflow): Promise<Model_ResponseWorkflow> {
        return new Promise((resolve, reject) => {
            this.doGetResponsesAction().then((_datasTable: Model_ResponseWorkflow[]) => {
                let itemIndex = -1;
                var newDatas = _datasTable;
                if (_response.ID === undefined && _response.GUID_SYNCHRONISATION === undefined) {
                    _response.DATE_CREATION = moment().format();
                    _response.GUID_SYNCHRONISATION = Guid.create().toString();
                    _response.SYNCED = false;
                    newDatas.push(_response);
                    itemIndex = newDatas.length - 1;
                } else {
                    itemIndex = _datasTable.findIndex(i => i.ID != _response.ID || i.GUID_SYNCHRONISATION == _response.GUID_SYNCHRONISATION);
                    if (itemIndex > -1) {
                        newDatas[itemIndex] = _response;
                        newDatas[itemIndex].DATE_MODIFICATION = moment().format();
                    }
                }
                localStorage.setItem(TB_RESPONSES_NAME, JSON.stringify(newDatas));
                resolve(newDatas[itemIndex]);
            }, err => {
                reject(err);
            });
        });
    }

    doGetResponseAction(_guid: string): Promise<Model_ResponseWorkflow> {
        return new Promise((resolve, reject) => {
            this.doGetResponsesAction().then((_datasTable: Model_ResponseWorkflow[]) => {
                const response = _datasTable.find(w => w.GUID_SYNCHRONISATION == _guid);
                resolve(response);
            }, err => reject(err));
        });
    }

    doDeleteResponseWorkflowAction(_guid: string): Promise<void> {
        return new Promise((resolve, reject) => {
            this.doGetResponsesAction().then((_datasTable: Model_ResponseWorkflow[]) => {
                const responseIndex = _datasTable.findIndex(w => w.GUID_SYNCHRONISATION == _guid);
                _datasTable.splice(responseIndex, 1);
                localStorage.setItem(TB_RESPONSES_NAME, JSON.stringify(_datasTable));
            }, err => reject(err));
        });
    }
}
